import "./App.css";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Platforms from "./components/Platforms";
import Education from "./components/Education";
import Contact from "./components/Contact";

function App() {

  useEffect(() => {

    const reveals = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver((entries) => {

      entries.forEach(entry => {

        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }

      });

    }, { threshold: 0.15 });

    reveals.forEach(el => observer.observe(el));

  }, []);

  return (
    <>
      <video autoPlay muted loop playsInline className="background-video">
        <source src="/images/background.mp4" type="video/mp4" />
      </video>

      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Platforms />
      <Education />
      <Contact />
    </>
  );
}

export default App;




